// extracted by mini-css-extract-plugin
export default {"heading":"Nz-z","corrected":"Oz-z","redirectVerbiageContainer":"Pz-z","redirectVerbiageText":"Qz-z"};